import { render, staticRenderFns } from "./BenefitsCreateForm.vue?vue&type=template&id=0c427c12"
import script from "./BenefitsCreateForm.vue?vue&type=script&lang=js"
export * from "./BenefitsCreateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports